import { GridLocaleText } from "@mui/x-data-grid";
import { TFunction } from "i18next";

export const generateDataGridLocaleTexts = (
  t: TFunction
): Partial<GridLocaleText> =>
  Object.fromEntries(
    Object.entries({
      columnsManagementReset: "button.reset",
      columnsManagementShowHideAllText: "button.showHideAll",
      columnsManagementSearchTitle: "filter.search.placeholder",
      columnsManagementNoColumns: "dataGridPro.columnsManagement.noColumns",
      noResultsOverlayLabel: "table.filters.noResults.title",
      toolbarColumns: "dataGridPro.columnsManagement.button.name",
      toolbarColumnsLabel: "dataGridPro.columnsManagement.button.tooltip",
    } as Partial<GridLocaleText>).map(([key, value]) => [
      key,
      t(`common:${value}`),
    ])
  );
